const DischargePlanStatuses = {
  NOT_STARTED: { code: 'NOT_STARTED', label: 'Not Started' },
  PREPPING: { code: 'PREPPING', label: 'Prepping' },
  SIGNED: { code: 'SIGNED', label: 'Signed' },
};

const IsPatientSeekingCares = {
  NO: { code: 'NO', label: 'No' },
  UNKNOWN: { code: 'UNKNOWN', label: 'Unknown' },
  YES: { code: 'YES', label: 'Yes' },
};

const CharacterLimit = 4000;

export { DischargePlanStatuses, IsPatientSeekingCares, CharacterLimit };
